import {MenuInterface} from "../../../interface/menu.interface";
import React from "react";
import Box from "@mui/material/Box";
import {config} from "../../../common/config/config";
import {styles} from "../../../common/style";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {FormControl, FormControlLabel, Radio, RadioGroup} from "@mui/material";

export default function ShareBoardInputComponent(
    props: {
        menu: MenuInterface,
        state: any,
        changeShareStatus: any,
        changeAmount: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void
    }
) {
    return <>
        {/* 나눔공간 게시판 전용 Input */}
        <Box sx={{
            width: 1,
            display: config.shareBoardList.includes(props.menu.id) ? 'flex' : 'none',
            justifyContent: 'flex-start', alignItems: 'center',
            mb: 1,
            border: styles.border,
            backgroundColor: 'var(--scc-surface)', borderRadius: 1,
        }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: 1,
                p: 2,
                width: 100,
                backgroundColor: '#696969'
            }}>
                <Typography sx={{color: 'white'}}> 수량 </Typography>
            </Box>
            <Box sx={{flexGrow: 1}}>
                <TextField type={'number'}
                           value={props.state.amount}
                           onChange={(e) => props.changeAmount(e)}
                           sx={{
                               width: 1,
                               'fieldset': {
                                   border: '0px',
                               }
                           }}/>
            </Box>
        </Box>


        {/* 나눔공간 상태값 Input */}
        <Box sx={{
            width: 1,
            display: config.shareBoardList.includes(props.menu.id) ? 'flex' : 'none',
            justifyContent: 'flex-start', alignItems: 'center',
            mb: 1,
            border: styles.border,
            backgroundColor: 'var(--scc-surface)', borderRadius: 1,
        }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: 1,
                p: 2,
                width: 100,
                backgroundColor: '#696969'
            }}>
                <Typography sx={{color: 'white'}}> 상태 </Typography>
            </Box>
            <Box sx={{flexGrow: 1}}>
                <FormControl>
                    <RadioGroup
                        row
                        aria-labelledby="demo-form-control-label-placement"
                        name="position"
                        defaultValue="top"
                        onChange={(e) => props.changeShareStatus(e)}
                    >
                        <FormControlLabel
                            value="0"
                            checked={props.state.shareStatus == 0 ? true : false}
                            control={<Radio/>}
                            label="나눔 중"
                            labelPlacement="start"
                        />
                        <FormControlLabel
                            value="1"
                            checked={props.state.shareStatus == 1 ? true : false}
                            control={<Radio/>}
                            label="나눔 완료"
                            labelPlacement="start"
                        />
                    </RadioGroup>
                </FormControl>
            </Box>
        </Box>
    </>;
}
